var element;

function init(message, type = 'success') {
  if(element) {
    element.remove();
    removeEventListeners();
  }
  element = document.createElement('div');
  element.classList.add('notification');
  element.innerHTML = message;
  if(type == 'error') {
    element.classList.add('notification--error');
  }
  document.body.insertAdjacentElement('afterbegin', element);

  window.addEventListener('scroll', handleOnScroll.bind(window.pageYOffset));
  document.body.addEventListener('click', remove);
}

function handleOnScroll(e) {
  if(Math.abs(this - window.pageYOffset) > 150) {
    remove();
  }
}

function remove() {
  element.classList.add('notification--removing');
  setTimeout(function() {
    element.remove();
  }, 1000);
  removeEventListeners();
}

function removeEventListeners() {
  document.body.removeEventListener('click', remove);
  window.removeEventListener('scroll', handleOnScroll);
}

export default {
  init: init,
  remove: remove
};
